export const FormSubmitValidityIndicator = {

    selectors: {
        submits: Array.prototype.slice.call(document.querySelectorAll('.js-form-submit-validity-indicator--submit')),
        stopSelectors: Array.prototype.slice.call(document.querySelectorAll('.js-form-submit-validity-indicator--stop')),
    },

    init: function() {
        let self = this;

        if (self.selectors.submits) {
            self.selectors.submits.forEach(function(submit) {

				submit.addEventListener('click', function(event) {
					let form = submit.closest('form');
					self.initInputsChangeStateEvent(form);

					if (form.checkValidity()) {
						self.indicateValidForm(form);

						if (typeof submit.dataset.dispatchOnValidForm === 'string') {
							eval.call(window, submit.dataset.dispatchOnValidForm);
						}
					} else {
						self.indicateInvalidForm(form);

						if (String(submit.dataset.stopOnInvalidForm) === '1') {
							event.preventDefault();
							event.stopImmediatePropagation();
						}
					}
				});
            });
        }

		if (self.selectors.stopSelectors) {
			self.selectors.stopSelectors.forEach(function(selector) {

				selector.addEventListener('click', function() {
					self.indicateValidForm(selector.closest('form'));
				});
			});
		}
    },

	initInputsChangeStateEvent: function(form) {
		let self = this;

		Array.prototype.forEach.call(form.elements, function(element) {
			element.addEventListener('change', function() {
				self.indicateValidForm(element.closest('form'));
			});
		});
	},

	indicateValidForm: function(form) {
		form.classList.remove('form--invalid');
		form.classList.add('form--valid');
	},

	indicateInvalidForm: function(form) {
		form.classList.remove('form--valid');
		form.classList.add('form--invalid');
	}
};

FormSubmitValidityIndicator.init();
